import moment from 'moment';
import React from 'react';
import { OrgUnitSelect } from '../../../components';
import { DatePicker } from '../../../components/ant/DatePicker';
import { FormField } from '../../../components/Form';
import { StyledInputNumber } from '../../../components/hoc/common/components/elements';

import CommonForm, { type CommonFormProps } from '../../../components/hoc/common/handbook/CommonForm';
import Grid, { GridItem } from '../../../components/layout/Grid';
import { ApproveYesNoSelect } from '../../../components/selects/AutoGeneratedEnumSelects';
import DriverLicenseCategorySelect from '../../../components/selects/DriverLicenseCategorySelect';
import type { VehicleGroupAndType } from '../../../components/selects/VehicleTypeSelect';
import VehicleTypeSelect from '../../../components/selects/VehicleTypeSelect';
import type { InspectionGibddCost } from '../../../lib/types';

export default (props: CommonFormProps<$Shape<InspectionGibddCost>>) => {
  return (
    <CommonForm {...props}>
      {({ setFieldValue, values }) => {
        return (
          <>
            <Grid gutter='16px'>
              <GridItem>
                <FormField label='Филиал' fast required name='orgUnitId'>
                  {({ name, value }) => (
                    <OrgUnitSelect
                      value={value}
                      onlyBranches
                      onChange={value => setFieldValue(name, value)}
                    />
                  )}
                </FormField>
              </GridItem>
              <GridItem>
                <FormField
                  label="Стоимость за один осмотр (работа) "
                  fast
                  required
                  name="cost"
                >
                  {({ name, value }) => (
                    <StyledInputNumber
                      name={name}
                      value={value}
                      onChange={value => setFieldValue(name, value)}
                    />
                  )}
                </FormField>
              </GridItem>
              <GridItem>
                <FormField
                  label="Категория транспортного средства"
                  fast
                  required
                  name="rightsCategory"
                >
                  {({ name, value }) => (
                    <DriverLicenseCategorySelect
                      showAllCategories
                      name={name}
                      value={value}
                      onChange={(rightsCategory: string) =>
                        setFieldValue(name, rightsCategory)
                      }
                      placeholder="Выберите категорию прав"
                    />
                  )}
                </FormField>
              </GridItem>
              <GridItem>
                <FormField
                  label="Тип ТС которые подлежат прохождению ТО в ГИБДД"
                  fast
                  required
                  name="vehicleType"
                >
                  {({ name, value }) => (
                    <VehicleTypeSelect
                      resultAsObject
                      onChange={({ type }: VehicleGroupAndType) => {
                        setFieldValue(name, type);
                      }}
                      value={value}
                    />
                  )}
                </FormField>
              </GridItem>
              <GridItem>
                <FormField
                  label="Периодичность прохождения ТО в ГИБДД для Типа ТС (мес)"
                  fast
                  required
                  name="maintenanceIntervals"
                >
                  {({ name, value }) => (
                    <StyledInputNumber
                      name={name}
                      value={value}
                      onChange={value => setFieldValue(name, value)}
                    />
                  )}
                </FormField>
              </GridItem>
              <GridItem>
                <FormField label="Статус" fast required name="status">
                  {({ name, value }) => (
                    <ApproveYesNoSelect
                      name={name}
                      value={value}
                      onChange={value => setFieldValue(name, value)}
                    />
                  )}
                </FormField>
              </GridItem>
              <GridItem>
                <FormField label="Дата начала" name="startDate" required>
                  {({ name, value }) => (
                    <DatePicker
                      name={name}
                      value={value ? moment(value) : value}
                      format="DD MMMM YYYY"
                      onChange={(value: string) => {
                        setFieldValue(
                          name,
                          moment
                            .utc(value)
                            .startOf('day')
                            .toISOString()
                        );
                      }}
                    />
                  )}
                </FormField>
              </GridItem>
              <GridItem>
                <FormField label="Дата окончания" name="endDate" required>
                  {({ name, value }) => (
                    <DatePicker
                      name={name}
                      value={value ? moment(value) : value}
                      format="DD MMMM YYYY"
                      disabled={!values.startDate}
                      disabledDate={(date: string) =>
                        values.startDate
                          ? moment
                            .utc(date)
                            .startOf('day')
                            .isSameOrBefore(moment.utc(values.startDate))
                          : false
                      }
                      onChange={(value: string) => {
                        setFieldValue(
                          name,
                          moment
                            .utc(value)
                            .startOf('day')
                            .toISOString()
                        );
                      }}
                    />
                  )}
                </FormField>
              </GridItem>
            </Grid>
          </>
        );
      }}
    </CommonForm>
  );
};
